<script lang="ts">
    import {onMount, setContext} from "svelte";
    import {getEmailTemplates} from "$lib/calls/mail";
    import SortableTable from "$lib/components/SortableTable.svelte";
    import {mailTemplates} from "$lib/utils/tableHeaders/mailTemplates";

    import {writable} from "svelte/store";
    import EmailTemplateEditModal from "$lib/partials/settings/EmailTemplateEditModal.svelte";
    import {globalConfirm} from "$lib/stores/modal";
    import {retire} from "$lib/api";
    import {Search} from "flowbite-svelte";

    let templates = [];
    let editModal = false;

    let search = '';

    let newTemplate = {
        id: null,
        name: '',
        subject: '',
        level: '',
        content: '',
        placeholders: <any>[]
    };
    const super_edit = writable(true);
    setContext('super_edit', super_edit);


    const fillEditor = (templateId:number) => {

       let templateIndex = templates.findIndex(x => x.id === templateId)
       newTemplate = {
            id: templates[templateIndex].id,
            name: templates[templateIndex].name,
            subject: templates[templateIndex]?.subject,
            level: templates[templateIndex].level,
            content: templates[templateIndex].content,
            placeholders: templates[templateIndex].placeholders
        }
        editModal = true
    }

    const deleteTemplate = async (templateId:number) => {
        let templateIndex = templates.findIndex(x => x.id === templateId)
        $globalConfirm.confirm('Template wirklich löschen?', () => {

            retire('/email-templates/' + templates[templateIndex].id)
            templates = templates.filter((x, i) => i !== templateIndex)
        })
    }


    onMount(async () => {

        templates = await getEmailTemplates()

    })


</script>
<Search bind:value={search}/>
<SortableTable header={mailTemplates(fillEditor, deleteTemplate)} data={templates.filter(x => x.name.toLowerCase().includes(search.toLowerCase()))}/>
{#if editModal}
<EmailTemplateEditModal
        on:new-template={(ev) => templates = [...templates, ev.detail]}
        on:template-update={(ev) => templates = templates.map(x => x.id === ev.detail.id ? ev.detail : x)}
        template={newTemplate} bind:open={editModal}/>
{/if}

